/**
 * Claude models offered in the recognizer model picker.
 *
 * The recognizer runtime (mod_voicebot) calls the Messages API with a forced
 * tool call to get schema-valid JSON back. Models that reject forced tool
 * use (Claude Fable 5.1, Claude Opus 5.5) are therefore left out on purpose.
 * Any other id can still be typed by hand — the picker is a combobox, not a
 * closed list.
 */
export type ModelTier = "fast" | "balanced" | "strong";

export interface ClaudeModelOption {
  id: string;
  label: string;
  hint: string;
  tier: ModelTier;
}

export const CLAUDE_MODELS: ClaudeModelOption[] = [
  {
    id: "claude-haiku-4-5",
    label: "Haiku 4.5",
    hint: "Fastest and cheapest. Good for yes/no and short extractions.",
    tier: "fast",
  },
  {
    id: "claude-sonnet-5",
    label: "Sonnet 5",
    hint: "Current Sonnet: strong reasoning at a mid-range latency.",
    tier: "balanced",
  },
  {
    id: "claude-sonnet-4-6",
    label: "Sonnet 4.6",
    hint: "Previous Sonnet generation.",
    tier: "balanced",
  },
  {
    id: "claude-sonnet-4-5",
    label: "Sonnet 4.5",
    hint: "Older Sonnet; the current choice for location_nl.",
    tier: "balanced",
  },
  {
    id: "claude-opus-5",
    label: "Opus 5",
    hint: "Most capable, slowest and most expensive. Rarely worth it for a recognizer.",
    tier: "strong",
  },
  {
    id: "claude-opus-4-8",
    label: "Opus 4.8",
    hint: "Previous Opus generation.",
    tier: "strong",
  },
  {
    id: "claude-opus-4-7",
    label: "Opus 4.7",
    hint: "Previous Opus generation.",
    tier: "strong",
  },
  {
    id: "claude-opus-4-6",
    label: "Opus 4.6",
    hint: "Previous Opus generation.",
    tier: "strong",
  },
];

/** What the runtime uses when a recognizer leaves the model empty. */
export const SERVER_DEFAULT_MODEL = "claude-haiku-4-5";

export const TIER_LABEL: Record<ModelTier, string> = {
  fast: "Fast",
  balanced: "Balanced",
  strong: "Strongest",
};
